import { render } from "./designSubForm.vue?vue&type=template&id=0086fa57&scoped=true"
import script from "./designSubForm.vue?vue&type=script&lang=js"
export * from "./designSubForm.vue?vue&type=script&lang=js"

import "./designSubForm.vue?vue&type=style&index=0&id=0086fa57&scoped=true&lang=scss"
import "./designSubForm.vue?vue&type=style&index=1&id=0086fa57&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0086fa57"]])

export default __exports__